import { mount } from './dom-lifecycle';

const READY = 'is-ready';

function bootHero(hero) {
    if (hero.dataset.heroBooted === '1') return;
    hero.dataset.heroBooted = '1';

    const start = () => requestAnimationFrame(() => {
        requestAnimationFrame(() => hero.classList.add(READY));
    });

    if (document.fonts && document.fonts.ready) {
        let started = false;
        const go = () => { if (!started) { started = true; start(); } };
        document.fonts.ready.then(go);
        setTimeout(go, 1500);
    } else {
        start();
    }

    if (!('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            hero.classList.toggle(READY, entry.isIntersecting);
        }
    }, { threshold: 0.15 });

    io.observe(hero);
}

export function initHero() {
    mount('[data-hero]', bootHero);
}

initHero();
